"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGlobalBeforeUnload = void 0;
var _react = require("react");
var useWindowEvent = function useWindowEvent(event, callback) {
  (0, _react.useEffect)(function () {
    window.addEventListener(event, callback);
    return function () {
      return window.removeEventListener(event, callback);
    };
  }, [event, callback]);
};
var useGlobalBeforeUnload = exports.useGlobalBeforeUnload = function useGlobalBeforeUnload(callback) {
  return useWindowEvent('beforeunload', callback);
};